import { plural } from '@cian/utils';
import { isSuburban } from '../category/isSuburban';
import { IOffer } from '../../../types/offer';

export function getFloorsForSuburban(offer: IOffer): string | undefined {
  if (isSuburban(offer) && offer.building && offer.building.floorsCount) {
    return `${offer.building.floorsCount} ${plural(offer.building.floorsCount, ['этаж', 'этажа', 'этажей'])}`;
  }

  return undefined;
}
